/* eslint-disable no-unused-expressions */

import React, { useEffect, useState } from 'react'

import classnames from 'classnames'
import { FcSalesPerformance, FcFrame } from 'react-icons/fc'
import { useSelector } from 'react-redux'
import { Link, useNavigate, useLocation } from 'react-router-dom'

import { ReactComponent as DeliveryMinTotalIcon } from '@kolayyolla/common/images/deliveryMinTotal.svg'
import { ReactComponent as WalletIcon } from '@kolayyolla/common/images/wallet.svg'
import { SortBy } from '@kolayyolla/common/utils/enums'
import { defaultPaymentTypes } from '@kolayyolla/common/utils/globalVars'

import { ExpandMore, FiberManualRecord, ImportExport, Payment } from '@mui/icons-material'
import { Checkbox, Chip, Collapse, Divider, FormControl, IconButton, List, ListItem, ListItemSecondaryAction, ListSubheader, MenuItem, Paper, Select, Slider, Link as MaterialLink, useMediaQuery, useTheme } from '@mui/material'
import { makeStyles } from '@mui/styles'

let isFirst = true

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.up('sm')]: {
      maxWidth: 300
    },
    width: '100%',
    margin: 'auto',
    position: 'sticky',
    top: 50 + parseInt(theme.spacing(1)),
    fontFamily: theme.typography.fontFamily,
    fontSize: 13
  },

  filterHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '1fr',
    gridTemplateAreas: '"left right"',

    '& .left': {
      gridArea: 'left'
    },

    '& .right': {
      gridArea: 'right',
      justifySelf: 'end'
    }
  },

  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest
    }),
    float: 'right',
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    },
    paddingLeft: 0
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  }

}))
const Filters   = () => {
  const classes    = useStyles()
  const navigate   = useNavigate()
  const theme      = useTheme()
  const location   = useLocation()
  const matches    = useMediaQuery(theme.breakpoints.up('sm'))
  const categories = useSelector((state) => state.category.data)

  const [category, setCategory]               = useState('')
  const [sortBy, setSortBy]                   = useState(SortBy.DISTANCE)
  const [canOrder, setCanOrder]               = useState(false)
  const [minRate, setMinRate]                 = useState(10)
  const [minTotal, setMinTotal]               = useState(50)
  const [minRateDisplay, setMinRateDisplay]   = useState(10)
  const [minTotalDisplay, setMinTotalDisplay] = useState(50)

  const [paymentType, setPaymentType]               = useState('any')
  const [loyaltyActive, setLoyaltyActive]           = useState(false)
  const [tableLoyaltyActive, setTableLoyaltyActive] = useState(false)
  const [searchQuery, setSearchQuery]               = useState('')

  const [expanded, setExpanded] = useState(matches)
  const handleExpandClick       = () => {
    setExpanded(!expanded)
  }

  useEffect(() => {
    setExpanded(matches)
  }, [matches])

  useEffect(() => {
    const urlQuery = {    }

    if (canOrder) urlQuery.online = canOrder

    if (loyaltyActive) urlQuery.loyalty = loyaltyActive

    if (tableLoyaltyActive) urlQuery.table = tableLoyaltyActive

    if (minTotal < 50 && minTotal > 0) urlQuery.mintotal = minTotal

    if (minRate > 10) urlQuery.minrate = minRate

    if (paymentType !== 'any') urlQuery.payment = paymentType

    if (sortBy !== SortBy.DISTANCE) urlQuery.sort = sortBy

    if (category) urlQuery.category = category

    if (searchQuery) urlQuery.q = searchQuery

    if (isFirst) {
      isFirst = false
    } else {
      navigate({
        pathname: location.pathname,
        search: new URLSearchParams(urlQuery).toString(),
        hash: location.hash
      })
    }
  },
  [canOrder, category, loyaltyActive, tableLoyaltyActive, minTotal, minRate, paymentType, sortBy, searchQuery])

  useEffect(() => {
    const query = new URLSearchParams(location.search)

    query.get('category') ? setCategory(query.get('category')) : setCategory('')
    query.get('q') && setSearchQuery(query.get('q'))
    query.get('online') && setCanOrder(query.get('online') === 'true')
    // query.get('coldsale')&&setIsColdSale(query.get('coldsale')==='true')

    query.get('loyalty') && setLoyaltyActive(query.get('loyalty') === 'true')
    query.get('table') && setTableLoyaltyActive(query.get('table') === 'true')
    // query.get('dist')&&setDistance(query.get('dist'))
    query.get('payment') && setPaymentType(query.get('payment'))
    query.get('sort') && setSortBy(query.get('sort'))

    if (query.get('mintotal')) {
      setMinTotal(query.get('mintotal'))
      setMinTotalDisplay(query.get('mintotal'))
    } else {
      setMinTotal(50)
      setMinTotalDisplay(50)
    }

    if (query.get('minrate')) {
      setMinRate(query.get('minrate'))
      setMinRateDisplay(query.get('minrate'))
    } else {
      setMinRate(10)
      setMinRateDisplay(10)
    }
  }, [location.search])

  const header = () => {
    return (
      <ListSubheader className={classes.filterHeader}>
        <div className="left"> Filtreler</div>

        <div className="right">
          {location.search !== '' && <Link to="./">Temizle</Link>}
          <IconButton
            className={classnames(classes.expand, { [classes.expandOpen]: expanded })}
            onClick={handleExpandClick}
            aria-expanded={expanded}
            aria-label="show more"
          >
            <ExpandMore />
          </IconButton>
        </div>

      </ListSubheader>
    )
  }

  return (
    <Paper className={classes.root} elevation={3}>
      <List subheader={header()} dense>
        <Collapse in={expanded} timeout="auto" unmountOnExit style={{ flexBasis: '100%' }}>
          {
            searchQuery && (
              <>
                <ListItem>
                  <div style={{ maxWidth: 250, whiteSpace: 'wrap' }}>
                    {`Aranan : "${searchQuery}"`}
                  </div>
                  <ListItemSecondaryAction>
                    <MaterialLink
                      component="button"
                      variant="body1"
                      onClick={() => {
                        setSearchQuery(null)
                      }}
                    >
                      X
                    </MaterialLink>
                  </ListItemSecondaryAction>
                </ListItem>
                <Divider />
              </>
            )
          }

          <ListItem>
            <FiberManualRecord style={{ color: '#c1f3d9' }} />
            Sadece Açık Olanlar
            <ListItemSecondaryAction>
              <Checkbox edge="end" color="primary" checked={canOrder} onChange={(e) => setCanOrder(e.target.checked)} />
            </ListItemSecondaryAction>
          </ListItem>

          <Divider />
          {/* <ListItem>
                        <ExploreOutlined /> Mesafeli Satış Yap. Göster
                    <ListItemSecondaryAction>
                            <Checkbox edge="end" color='primary' checked={isColdSale} onChange={e => setIsColdSale(e.target.checked)} />
                        </ListItemSecondaryAction>
                    </ListItem> */}
          <Divider />
          <ListItem style={{ display: 'inherit' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <WalletIcon style={{
                height: 24, width: 24, padding: 2, margin: 2
              }}
              />
              {' '}
              Sadece KumPara Kazandıranlar
            </div>

            <ListItemSecondaryAction>
              <Checkbox edge="end" color="primary" checked={loyaltyActive} onChange={(e) => setLoyaltyActive(e.target.checked)} />
            </ListItemSecondaryAction>
          </ListItem>

          <Divider />

          <ListItem style={{ display: 'inherit' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
            <FcFrame style={{
              height: 24, width: 24, padding: 2, margin: 2
            }}
              />
              {' '}
              Masada KumPara Kazandıranlar
            </div>

            <ListItemSecondaryAction>
              <Checkbox edge="end" color="primary" checked={tableLoyaltyActive} onChange={(e) => setTableLoyaltyActive(e.target.checked)} />
            </ListItemSecondaryAction>
          </ListItem>

          <Divider />
          <ListItem style={{ display: 'inherit' }} disabled={minRate === 10}>
            <div style={{ display: 'flex', alignItems: 'center' }}>

              <FcSalesPerformance style={{
                height: 24, width: 24, padding: 2, margin: 2
              }}
              />
              {' '}
              Min. Biriktiren Sipariş Oranı
            </div>

            <Slider
              value={minRateDisplay}
              onChange={(e, v) => setMinRateDisplay(v)}
              onChangeCommitted={(e, v) => setMinRate(v)}
              aria-labelledby="minrate-slider"
              valueLabelDisplay="auto"
              step={5}
              marks
              min={10}
              max={50}
            />
          </ListItem>
          <ListItem style={{ display: 'inherit' }} disabled={minTotal === 50}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <DeliveryMinTotalIcon style={{
                height: 24, width: 24, padding: 2, margin: 2
              }}
              />
              {' '}
              Min. Paket Tutarı
            </div>

            <Slider
              value={minTotalDisplay}
              onChange={(e, v) => setMinTotalDisplay(v)}
              onChangeCommitted={(e, v) => setMinTotal(v)}
              aria-labelledby="mintotal-slider"
              valueLabelDisplay="auto"
              step={5}
              marks
              min={0}
              max={50}
              valueLabelFormat={(value) => {
                return value === 50 ? 'Hepsi' : value
              }}
            />
          </ListItem>

          <Divider />
          {/* <ListItem style={{display: 'inherit'}} disabled={distance===5}>
                        <div style={{display: 'flex',alignItems: 'center'}}>
                            <DistanceIcon style={{height: 24,width: 24,padding: 2,margin: 2}} /> Mesafe
                    </div>

                        <Slider
                            value={distance}
                            onChangeCommitted={(e,v) => setDistance(v)}
                            aria-labelledby="distance-slider"
                            valueLabelDisplay="auto"
                            step={0.5}
                            marks
                            min={0}
                            max={5}
                            valueLabelFormat={(value) => {
                                return `${value}km`
                            }}
                        />
                    </ListItem> */}

          <Divider />
          <ListItem disabled={paymentType === 'any'}>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Payment />
                {' '}
                Ödeme Yöntemi
              </div>

              <FormControl variant="standard" style={{ minWidth: 180 }}>
                <Select
                  disableUnderline
                  labelId="paymentType-select-label"
                  id="paymentType-select"
                  value={paymentType}
                  onChange={(e) => { setPaymentType(e.target.value) }}
                >
                  <MenuItem value="any">Hepsi</MenuItem>
                  {
                    defaultPaymentTypes.map((pt) => <MenuItem key={pt.key} value={pt.key}>{pt.name}</MenuItem>)
                  }
                </Select>
              </FormControl>

            </div>
          </ListItem>

          <Divider />
          <ListItem>
            <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <ImportExport />
                {' '}
                Sıralama
              </div>

              <FormControl variant='standard' style={{ minWidth: 180, width: '100%' }}>
                <Select
                  disableUnderline
                  fullWidth
                  labelId="sort-select-label"
                  id="sort-select"
                  value={sortBy}
                  onChange={(e) => { setSortBy(e.target.value) }}
                >
                  <MenuItem value={SortBy.NAME}>Alfabetik</MenuItem>
                  <MenuItem value={SortBy.DISTANCE}>Mesafe</MenuItem>
                  <MenuItem value={SortBy.MIN_TOTAL}>Min. Sepet Tutarı</MenuItem>
                </Select>
              </FormControl>
            </div>
          </ListItem>

          {category && categories.find((c) => c.key === category)
            ? (
              <ListItem>
                <div style={{ display: 'flex', flexDirection: 'column' }}>

                  <Chip
                    label={categories.find((c) => c.key === category).name}
                    onDelete={() => {
                      const query = new URLSearchParams(location.search)
                      query.delete('category')
                      navigate({
                        pathname: '/',
                        search: query.toString()
                      })
                    }}
                  />
                </div>
              </ListItem>
              )
            : null}

        </Collapse>
      </List>

    </Paper>
  )
}

export default Filters
